/**
 * BrandMark
 * ---------
 * The homepage's brand lockup — 42×42 logo + "Athlo" upright / "Hive" serif
 * italic wordmark — for React screens that should read the same as the
 * homepage (public header, sign-in). Styles: styles/brandMark.css.
 *
 * Logo: the home page's cloud-hosted logo (LOGO_SRC), shown at 42×42; the
 * built-in hive mark if it fails to load. (Previously the application's branding logo
 * uploaded in the admin — the `logo` prop, now unused but still accepted.)
 *
 * Name: while branding is still loading (`pending`), a neutral placeholder —
 * never envConfig's name, which would flash on a slow network.
 */

import React, { useState } from 'react';
import '../../styles/brandMark.css';

function HiveMark() {
  return (
    <svg className="bm-logo" width="36" height="36" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M16 2.5l11.7 6.75v13.5L16 29.5 4.3 22.75V9.25z" fill="#FF6A1A" />
      <path d="M10 19.5l4-7 3 4.5 2-3 3 5.5" fill="none" stroke="#fff" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * A one-word CamelCase name splits at its last capital — "AthloHive" →
 * "Athlo" + "Hive". Any other name (spaces, one capital) is set whole upright.
 */
export function Wordmark({ name }) {
  const m = /^(\S*[a-z])([A-Z][^A-Z\s]*)$/.exec(name);
  return (
    <span className="bm-wordmark">
      {m ? <><span className="bm-wm-a">{m[1]}</span><span className="bm-wm-b">{m[2]}</span></> : <span className="bm-wm-a">{name}</span>}
    </span>
  );
}
const LOGO_SRC = 'https://storage.athlohive.com/files/2/2/22eabab6-bc47-4cff-9021-4b07c253763d';

export default function BrandMark({ name, logo = null, pending = false }) {
  // Remember which URL failed, so a new logo (branding arriving later) gets
  // its own chance to load.
  // const [failed, setFailed] = useState(null);
  // const showLogo = logo && failed !== logo;
  const [failed, setFailed] = useState(false);
  return (
    <>
      {/* Previously the admin branding logo, with a placeholder while it loaded:
      {pending && !logo
        ? <span className="bm-skel bm-skel-logo" aria-hidden="true" />
        : showLogo ? <img className="bm-logo" src={logo} alt="" onError={() => setFailed(logo)} /> : <HiveMark />} */}
      {failed
        ? <HiveMark />
        : <img className="bm-logo" src={LOGO_SRC} alt="" onError={() => setFailed(true)} />}
      {pending ? <span className="bm-skel" aria-hidden="true" /> : <Wordmark name={name} />}
    </>
  );
}
